import { InMemoryCache } from '@apollo/client';

const apolloCache = new InMemoryCache();

export default apolloCache;

